import { useMediaQuery } from "@heroui/react";
import { motion, useReducedMotion } from "motion/react";
import { ReactNode } from "react";

const ANIM = {
  desktopLeft: { opacity: 0, x: 80, y: 0 },
  desktopRight: { opacity: 0, x: -60, y: 0 },
  mobile: { opacity: 0, x: 0, y: 24 },
  transition: { duration: 0.8, ease: "easeOut" },
  viewport: { once: true, amount: 0.3 },
} as const;

export default function MotionCol({
  children,
  side = "left",
  className = "",
}: {
  children: ReactNode;
  side?: "left" | "right";
  className?: string;
}) {
  const isDesktop = useMediaQuery("(min-width: 768px)", {
    defaultValue: false,
    initializeWithValue: false,
  });
  const shouldReduceMotion = useReducedMotion();
  const desktopInitial = side === "left" ? ANIM.desktopLeft : ANIM.desktopRight;
  const initial = isDesktop ? desktopInitial : ANIM.mobile;

  return (
    <motion.div
      className={className}
      initial={shouldReduceMotion ? false : initial}
      transition={shouldReduceMotion ? { duration: 0 } : ANIM.transition}
      viewport={ANIM.viewport}
      whileInView={{ opacity: 1, x: 0, y: 0 }}
    >
      {children}
    </motion.div>
  );
}
